<script setup>
const props = defineProps({
  escalation: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['applyAction']);

const getPriorityColor = priority => {
  const colors = {
    urgent: 'bg-r-100 border-r-300 dark:bg-r-900/30 dark:border-r-700',
    high: 'bg-o-100 border-o-300 dark:bg-o-900/30 dark:border-o-700',
    medium: 'bg-y-100 border-y-300 dark:bg-y-900/30 dark:border-y-700',
    low: 'bg-n-solid-3 border-n-weak',
  };
  return colors[priority] || colors.medium;
};

const getPriorityTextColor = priority => {
  const colors = {
    urgent: 'text-r-700 dark:text-r-400',
    high: 'text-o-700 dark:text-o-400',
    medium: 'text-y-700 dark:text-y-400',
    low: 'text-n-slate-11',
  };
  return colors[priority] || colors.medium;
};

const handleAssignTeam = () => {
  emit('applyAction', {
    type: 'assign_team',
    team: props.escalation.suggestedTeam,
  });
};
</script>

<template>
  <div
    class="rounded-lg p-4 border"
    :class="getPriorityColor(escalation.priority)"
  >
    <div class="flex items-start gap-3">
      <span
        class="i-lucide-alert-triangle text-xl flex-shrink-0"
        :class="getPriorityTextColor(escalation.priority)"
      />
      <div class="flex-1 min-w-0">
        <h4
          class="text-sm font-semibold"
          :class="getPriorityTextColor(escalation.priority)"
        >
          {{ $t('AGENTS_SIDECAR.ESCALATION.TITLE') }}
        </h4>
        <p class="text-sm text-n-slate-11 mt-1">
          {{ escalation.reason }}
        </p>

        <div
          v-if="escalation.suggestedTeam || escalation.suggestedAssignee"
          class="mt-3 flex flex-wrap gap-2"
        >
          <button
            v-if="escalation.suggestedTeam"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-n-solid-1 border border-n-weak hover:bg-n-solid-3 transition-colors"
            @click="handleAssignTeam"
          >
            <span class="i-lucide-users" />
            {{
              $t('AGENTS_SIDECAR.ESCALATION.ASSIGN_TO', {
                team: escalation.suggestedTeam,
              })
            }}
          </button>
        </div>

        <div class="mt-2 flex items-center gap-2 text-xs text-n-slate-10">
          <span class="capitalize">
            {{ $t('AGENTS_SIDECAR.ESCALATION.PRIORITY') }}:
            {{ escalation.priority }}
          </span>
          <span v-if="escalation.confidence">
            • {{ Math.round(escalation.confidence * 100) }}%
            {{ $t('AGENTS_SIDECAR.ESCALATION.CONFIDENCE') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
